import { awExposureSearchApi } from './Base';
import { ExposureSearchCreateReportPath, ExposureSearchReport, ExposureSearchRequestPayload } from './Models';

export const createExposureSearchReport = (
  requestType: ExposureSearchCreateReportPath,
  payload: ExposureSearchRequestPayload
) => {
  const path = `/api/v1/${requestType}`;
  return awExposureSearchApi.post<string>(path, payload, { params: { pkg: payload.pkg } });
};

export const deleteReport = (reportId: string) => {
  const path = `/api/v1/reports/${reportId}`;
  return awExposureSearchApi.delete(path);
};

export const getExposureSearchReport = <T extends ExposureSearchCreateReportPath>(
  requestType: T,
  id: string,
  pkg?: string
) => {
  const path = `/api/v1/${requestType}/${id}`;
  return awExposureSearchApi.get<ExposureSearchReport<T>>(path, { params: { pkg } });
};
